var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    [
      _c("ik-form-popup-select", {
        attrs: {
          name: "neirong",
          code: "name",
          url: "health/content/content/infotype",
        },
        model: {
          value: _vm.result,
          callback: function ($$v) {
            _vm.result = $$v
          },
          expression: "result",
        },
      }),
      _c(
        "el-form-item",
        [_c("el-button", { on: { click: _vm.submit } }, [_vm._v("提交")])],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }